export default {
      id: "icon-chevron-usage",
      viewBox: "0 0 25.267 12.122",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-chevron",
      toString: function () {
        return this.url;
      }
    }